import { useMarketStore } from '@/stores/marketStore';
import { butterflyCardContext } from '../SpreadsTotals/butterflyContext';
import type { GameEventRow, SpreadLine, TotalLine } from '../ValueDashboard/types';

/** Called by market-version-subscribed sections for the row's own exact line. */
export function lineLadderReference(event: GameEventRow | null | undefined,
  kind: string, line: SpreadLine | TotalLine | undefined, period = 'full') {
  if (!event || !line || (kind !== 'spread' && kind !== 'total')) return undefined;
  const store = useMarketStore.getState();
  const context = butterflyCardContext(event, kind, line, {
    spread: store.getOpSpreadLineFor, total: store.getOpTotalLineFor, markets: store.getOpMarketsFor,
  }, period);
  return { fair: context.fairView, yesIsAway: context.yesIsAway, strike: context.strike };
}
